// import Service from '@/service/index.js';

export default {
  components: {
  },
  props: {

  },
  data() {
    return {

    };
  },
  created() {

  },
  computed: {

  },
  methods: {

  }
};
